import { render, staticRenderFns } from "./HomePageRouter.vue?vue&type=template&id=c04ffa9e"
import script from "./HomePageRouter.vue?vue&type=script&lang=js"
export * from "./HomePageRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports